import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Col, Form, Input, notification, Row, Spin } from 'antd';

import './ProfileForm.scss';

const API_URL = process.env.API_URL;
const jwt = () => localStorage.getItem('jwt');
const FormItem = Form.Item;

export class ProfileForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            confirmDirty: false,
            isLoading: false
        }
    }

    compareToFirstPassword(rule, value, callback) {
        console.log(rule, value, callback)
        const { form } = this.props;
        if (value && value !== form.getFieldValue('new_password')) {
            callback('Two passwords are inconsistent.');
        } else {
            callback();
        }
    }

    validateToNextPassword(rule, value, callback) {
        const { form } = this.props;
        const { confirmDirty } = this.state;
        if (value && confirmDirty) {
            form.validateFields(['confirm_new_password'], { force: true });
        }
        callback();
    }

    handleSubmit(e) {
        const { form } = this.props;

        e.preventDefault();
        this.setState({ isLoading: true });

        form.validateFields((err, values) => {
            if (!err) {
                fetch(`${API_URL}/auth/profile`, {
                        method: 'PUT',
                        mode: 'cors',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `bearer ${jwt()}`
                        },
                        body: JSON.stringify(values)
                    })
                    .then((res) => res.json())
                    .then((json) => {
                        if (json.error) {
                            notification.error({
                                message: 'Error',
                                description: json.error.message,
                                duration: 0
                            });
                        } else
                            notification.success({
                                message: 'Success',
                                description: 'Successfully update your profile.',
                                duration: 0
                            })
                        this.setState({ isLoading: false });
                    })
                    .catch((err) => {
                        notification.error({
                            message: 'Unexpected Error',
                            description: 'Please report this issue to engineer.',
                            duration: 0
                        });
                        this.setState({ isLoading: false });
                    })
            } else {
                this.setState({ isLoading: false });
            }
        });
    }

    render() {
        const { form, userName } = this.props;
        const { isLoading } = this.state;
        const { getFieldDecorator } = form;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 12 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 12 },
            },
        };

        return (
            <Spin spinning={isLoading}>
                <Form className="ProfileForm" onSubmit={(e) => this.handleSubmit(e)}>
                    <Row gutter={32}>
                        <Col span={24}>
                            <FormItem {...formItemLayout} label="Name">
                                {
                                    getFieldDecorator('name', {
                                        rules: [{
                                            required: true,
                                            message: 'This field is required.'
                                        }],
                                        initialValue: userName
                                    })(
                                        <Input 
                                            style={{ width: 200 }}
                                        />
                                    )
                                }
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={24}>
                            <FormItem {...formItemLayout} label="Current Password">
                                {
                                    getFieldDecorator('current_password', {
                                        rules: [{
                                            required: true,
                                            message: 'This field is required.'
                                        }]
                                    })(
                                        <Input 
                                            type="password"
                                            style={{ width: 200 }}
                                        />
                                    )
                                }
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={24}>
                            <FormItem {...formItemLayout} label="New Password">
                                {
                                    getFieldDecorator('new_password', {
                                        rules: [{
                                            validater: (rule, value, callback) => this.validateToNextPassword(rule, value, callback)
                                        }]
                                    })(
                                        <Input 
                                            type="password"
                                            style={{ width: 200 }}
                                        />
                                    )
                                }
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={24}>
                            <FormItem {...formItemLayout} label="Confirm New Password">
                                {
                                    getFieldDecorator('confirm_new_password', {
                                        rules: [{
                                            validator: (rule, value, callback) => this.compareToFirstPassword(rule, value, callback)
                                        }]
                                    })(
                                        <Input
                                            type="password"
                                            style={{ width: 200 }}
                                        />
                                    )
                                }
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <FormItem>
                            <Button type="primary" htmlType="submit">Update</Button>
                        </FormItem>
                    </Row>
                </Form>
            </Spin>
        );
    }
}

const mapStateToProps = (state) => ({
    userId: state.user.id,
    userName: state.user.name
})

const WrappedProfileForm = Form.create()(ProfileForm);
export default connect(mapStateToProps)(WrappedProfileForm);


// WEBPACK FOOTER //
// ./src/scenes/DashboardPage/scenes/ProfilePage/components/ProfileForm/ProfileForm.js